import { defineStore } from 'pinia'
import APIService from '@/services/APIService.js'


export const licenseStore = defineStore('licenseStore', {
    state: () => {
        return {

           licenses: null

        }
    },
    getters: {



    },

    actions: {


        hasLicense(license){


            return true;

        }

    },


})
